import script from "./AdminNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminNotice.vue?vue&type=script&setup=true&lang=ts"

import "./AdminNotice.vue?vue&type=style&index=0&id=dfa44732&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfa44732"]])

export default __exports__